import classNames from 'classnames';
import css from './AdditionalDataRow.module.less';

type Props = {
  valueField: JSX.Element;
  dataSourceField: JSX.Element;
  showDataSource: boolean;
};

const AdditionalDataRow = ({ showDataSource, valueField, dataSourceField }: Props) => (
  <div className={css.additionalDataRowContainer}>
    <div
      className={classNames({
        [css.additionalDataRowItem]: showDataSource,
        [css.fullWidth]: !showDataSource,
      })}
    >
      {valueField}
    </div>
    <div
      className={classNames('u-p-left-1x', {
        [css.additionalDataRowItem]: showDataSource,
        [css.hide]: !showDataSource,
      })}
    >
      {dataSourceField}
    </div>
  </div>
);

export default AdditionalDataRow;
